// ProfileTabs.js - 會員中心分頁控制器（會員資料 / 修改密碼 / 安全紀錄）
// 2026-05-21 重寫：拿掉大張背景圖、改成 "我的會員" 標題 + pill 樣式 tabs
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useEffect, useContext, useState, useMemo } from "react";
import { Card, Divider } from "@mui/material";
import Tabs from "components/mas/Tabs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import EditProfile from "./EditProfile";
import ChangePasswordPage from "./ChangePasswordPage";
import UserSecurityActivityPage from "./UserSecurityActivityPage";
import DiscordBindTab from "./DiscordBindTab";
import PromoCodeRedeemTab from "./PromoCodeRedeemTab";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "../../../../context/LanguageContext";

export default function ProfileTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("ProfileTabs", "profile/ProfileTabs/ProfileTabs_lang");
    loadLanguageFile("EditProfile", "profile/EditProfile/EditProfile_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.ProfileTabs || { Main: {} };
  const EDIT_LANG = useMemo(
    () => componentLanguageData.EditProfile || { Main: {} },
    [componentLanguageData]
  );
  const pageTitle = EDIT_LANG.Main?.PageTitle || "我的會員";

  const tabMap = ["/profile/edit", "/profile/security", "/profile/activity", "/profile/discord", "/profile/redeem"];
  const initialTab = tabMap.findIndex((p) => location.pathname.startsWith(p));
  const [tabValue, setTabValue] = useState(initialTab !== -1 ? initialTab : 0);

  useEffect(() => {
    const idx = tabMap.findIndex((p) => location.pathname.startsWith(p));
    if (idx !== -1) setTabValue(idx);
  }, [location.pathname]);

  const handleTabChange = (_, newValue) => {
    if (newValue === null) return; // 防止取消選擇
    setTabValue(newValue);
    navigate(tabMap[newValue]);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox p={{ xs: 2, md: 3 }}>
        {/* 頁面標題 */}
        <MDTypography variant="h5" fontWeight="bold" mb={3}>
          {pageTitle}
        </MDTypography>

        {/* 大白色容器：包 tabs + 內容（對齊截圖二 design） */}
        <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, boxShadow: 1 }}>
          {/* Tabs：共用 pill（灰底容器、selected 白按鈕 + 陰影）
              2026-05-25 外層包 flex，讓灰底縮到內容寬（跟 MAS Coin/推薦中心一致，不再滿版）*/}
          <div style={{ display: "flex" }}>
            <Tabs
              variant="pill"
              value={tabValue}
              onChange={(v) => handleTabChange(null, v)}
              tabs={[
                { value: 0, label: LANGUAGE.Main.Content1 || "會員資料" },
                { value: 1, label: LANGUAGE.Main.Content2 || "修改密碼" },
                { value: 2, label: LANGUAGE.Main.Content3 || "安全紀錄" },
                { value: 3, label: LANGUAGE.Main.Content4 || "Discord" },
                { value: 4, label: LANGUAGE.Main.Content5 || "優惠碼" },
              ]}
            />
          </div>

          <Divider sx={{ my: 2 }} />

          {/* 對應內容 */}
          <Routes>
            <Route path="*" element={<Navigate to="edit" replace />} />
            <Route path="edit" element={<EditProfile />} />
            <Route path="security" element={<ChangePasswordPage />} />
            <Route path="activity" element={<UserSecurityActivityPage />} />
            <Route path="discord" element={<DiscordBindTab />} />
            <Route path="redeem" element={<PromoCodeRedeemTab />} />
          </Routes>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
